import { config } from "../constants";
import { authHeader } from "../helpers";
import { handleResponse } from "./handle-response";

// Partner's own sales report. `all_category_products=true` makes the backend return
// every active product of the report category (FDF / API / Diagnostics) in
// `product_order`, not only the ones assigned to the partner.
const partnerSalesReportUrl = (type, quarter_name) => {
  const params = new URLSearchParams({ all_category_products: "true" });
  if (quarter_name !== null && quarter_name !== undefined) {
    params.set("quarter", quarter_name);
  }
  return `${config.API_URL}/template/sales/${type}?${params.toString()}`;
};

export const getSalesReport = (type, quarter_name) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(partnerSalesReportUrl(type, quarter_name), requestOptions).then(
    handleResponse,
  );
};

export const getDiagnosticsSalesReport = (quarter_name) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    partnerSalesReportUrl("diagnostics", quarter_name),
    requestOptions,
  ).then(handleResponse);
};

export const postSalesReport = (type, data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(`${config.API_URL}/template/sales/${type}`, requestOptions).then(
    handleResponse,
  );
};

export const postDiagnosticsSalesReport = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(`${config.API_URL}/template/sales/diagnostics`, requestOptions).then(
    handleResponse,
  );
};

// Admin view of a partner's report (API / FDF). `all_category_products=true` makes the
// backend return every active product of the category in `product_order`, not only
// the ones assigned to that partner.
export const adminGetSalesReport = (type, id, quarter_name) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  const params = new URLSearchParams({ all_category_products: "true" });
  if (quarter_name !== null && quarter_name !== undefined) {
    params.set("quarter", quarter_name);
  }

  return fetch(
    `${config.API_URL}/template/sales/${type}/${id}?${params.toString()}`,
    requestOptions,
  ).then(handleResponse);
};

export const adminPostSalesReport = (type, id, data, quarter_name) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  if (quarter_name === null || quarter_name === undefined) {
    return fetch(
      `${config.API_URL}/template/sales/${type}/${id}`,
      requestOptions,
    ).then(handleResponse);
  } else {
    return fetch(
      `${config.API_URL}/template/sales/${type}/${id}?quarter=` + quarter_name,
      requestOptions,
    ).then(handleResponse);
  }
};

export const adminGetDiagnosticsSalesReport = (id, quarter_name) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  if (quarter_name === null) {
    return fetch(
      `${config.API_URL}/template/sales/diagnostics/${id}`,
      requestOptions,
    ).then(handleResponse);
  } else {
    return fetch(
      `${config.API_URL}/template/sales/diagnostics/${id}?quarter=` + quarter_name,
      requestOptions,
    ).then(handleResponse);
  }
};

export const adminPostDiagnosticsSalesReport = (id, data, quarter_name) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  if (quarter_name === null || quarter_name === undefined) {
    return fetch(
      `${config.API_URL}/template/sales/diagnostics/${id}`,
      requestOptions,
    ).then(handleResponse);
  } else {
    return fetch(
      `${config.API_URL}/template/sales/diagnostics/${id}?quarter=` + quarter_name,
      requestOptions,
    ).then(handleResponse);
  }
};

export const submitSalesReport = ({ message }) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ message }),
  };

  return fetch(`${config.API_URL}/template/sales/submit/`, requestOptions).then(
    handleResponse,
  );
};

export const approveSalesReport = ({ partner_id, message, is_approved }) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ partner_id, message, is_approved }),
  };

  return fetch(
    `${config.API_URL}/template/sales/message/`,
    requestOptions,
  ).then(handleResponse);
};

export const markSalesReportMessageRead = (type) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${config.API_URL}/template/sales/inbox/${type}`,
    requestOptions,
  ).then(handleResponse);
};

export const getConsolidatedSalesReport = (type, data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(`${config.API_URL}/report/sales/${type}`, requestOptions).then(
    handleResponse,
  );
};

export const downloadConsolidatedSalesReport = (type, requestObj) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(requestObj),
    responseType: "blob",
  };

  return fetch(
    `${config.API_URL}/report/sales/download/${type}`,
    requestOptions,
  ).then((response) => response.blob());
};

export const getProductsToBeVerified = (id) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${config.API_URL}/template/product_verification/${id}`,
    requestOptions,
  ).then(handleResponse);
};

export const postProductsToBeVerified = (id, data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(
    `${config.API_URL}/template/product_verification/${id}`,
    requestOptions,
  ).then(handleResponse);
};
